import { memo } from 'react';
import {
  type InteractionColors,
  type InteractionOptions,
} from '@components/Presentation/types';
import OptionOrderType from './optionOrderType';
import useFonts from '@lib/hooks/useFonts';
import { computeLuminance } from '@lib/interactionHelper';
import { CheckCircleIcon } from '@phosphor-icons/react';

export interface IQuizOptions extends InteractionOptions {
  contribution?: string;
  count?: string;
  profileNames?: string[];
  otherCommenters?: number;
}

const QuizOptions = ({
  option,
  settings = {},
  index,
  relativeMax,
  showAnswer = false,
  colors,
  showResponses = true,
  roundedCorner = 'rounded-[40px]',
  parentContainer = { height: 'h-full' },
  chartColor,
  hasImage = false
}: {
  option: IQuizOptions;
  settings?: any;
  index: number;
  relativeMax: number;
  showAnswer?: boolean;
  colors: InteractionColors;
  showResponses?: boolean;
  roundedCorner?: string;
  parentContainer?: {
    height?: string;
  }
  chartColor: string;
  hasImage?: boolean;
}) => {
  const count = !showResponses ? 0 : parseInt(option?.count || '0', 10);

  const { getFontStyle } = useFonts();
  const fontStyle = getFontStyle(settings?.FontStyle || 'Sans-Serif');

  const { isBgLight } = computeLuminance(colors?.quizBgColor ?? colors?.multipleChoiceBgColor ?? '#111111');

  return (
    <div
      style={{
        opacity: showAnswer && !option.checked ? 0.3 : 1,
      }}
      className={`relative flex items-center justify-center h-full z-[2] ${parentContainer.height}  transition-all ease-linear duration-100`}>
      <div
        className={`absolute z-10 top-3 right-3 transition-all duration-100 ease-linear ${showAnswer ? '' : 'max-w-0 opacity-0'
        } overflow-hidden`}
      >
        {option.checked && (
          <CheckCircleIcon size={60} weight='fill' className={`${isBgLight ? 'text-black' : 'text-white'}`} />
        )}
      </div>

      <div className={`w-full h-full flex overflow-hidden  ${roundedCorner}`}>
        <div className="w-full h-full flex items-center relative">

          {/* Filled section */}
          {/* <div
            style={{
              width,
              //   background: colors?.multipleChoiceChartColor || '#E8634D',
              background: chartColor,
              opacity: showAnswer && !option.checked ? 0.1 : 0.5
            }}
            className="absolute left-0 top-0 h-full z-0 transition-all ease-linear duration-300"
          ></div> */}

          {/* Lightened section (background base) */}
          <div
            style={{
              width: '100%',
              left: 0,
              //   background: colors?.multipleChoiceChartColor || '#E8634D',
              background: chartColor,
              //   opacity: 0.5,
            }}
            className="absolute top-0 h-full z-0"
          ></div>

          {/* Foreground content */}
          <div className="relative z-10 flex w-full h-full items-center">
            <div className="flex gap-4 items-center w-full px-4 sm:px-8">
              <OptionOrderType
                index={index}
                // prefix={settings?.prefix}
                type={settings?.optionOrderType}
                // chartColor={colors?.multipleChoiceChartColor}
                chartColor={chartColor}
                textColor={colors?.quizLabelColor ?? colors?.multipleChoiceLabelColor}
              />

              {/* Option Text (left side) */}
              <span
                style={{
                  ...fontStyle,
                  lineHeight: 'normal',
                  fontSize: `${((option.body?.length || 0) < 100 ? (hasImage ? 38 : 46) : (hasImage ? 36 : 42)) * (Number(settings?.quizFontSize) || 1)}px`,
                  color: colors?.quizLabelColor ?? colors?.multipleChoiceLabelColor ?? '#FFF',
                }}
                className="multipleChoiceOptionText font-Inter font-semibold whitespace-pre-wrap"
              >
                {option.body}
              </span>
            </div>
          </div>

          {count && <div className='absolute bottom-0 left-1/2 -translate-x-1/2 bg-black/20 w-14 h-8 grid place-items-center rounded-t-lg text-medium font-semibold'>
            {count}
          </div>}
        </div>
      </div>

    </div>
  );
};

export default memo(QuizOptions);
